import { Injectable, Output, EventEmitter } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CookieService {
  @Output() cartNumber: EventEmitter<any> = new EventEmitter<any>();

  constructor() { }

  public addToCart(id: string) {
    const items = this.getCartCookieInfo();

    // if cart has stuff in it
    let cvalue = `${id}[1]`;
    let itemNum = '1';
    if (items.length > 0) {
      const itemArray = this.getCartItems(items);
      if (itemArray.includes(id)) {
        cvalue = items;
      } else {
        itemArray.push(id);
        cvalue = `${items},${id}[1]`;
      }
      itemNum = itemArray.length.toString();
    }

    this.updateCartItems(cvalue, itemNum);
  }

  private getCartCookieInfo(): string {
    const name = 'shopping_cart=';
    const ca = document.cookie.split(';');
    for (let i of ca) {
      while (i.charAt(0) === ' ') {
        i = i.substring(1);
      }
      if (i.indexOf(name) === 0) {
        return i.substring(name.length, i.length);
      }
    }
    return '';
  }

  public getCartItems(item_string?: string): string[] {
    const items = item_string ? item_string : this.getCartCookieInfo();
    if (items === "") {
      return [];
    }
    const itemsAndAmount = items.split(',');
    const regex = /^(.+)\[\d+\]/;
    const parsedItems = itemsAndAmount.map((i) => {
      let res = regex.exec(i);
      return res[1];
    });
    return parsedItems;
  }

  public getCartItemsAndQuantities(item_string?: string): string[] {
    const items = item_string ? item_string : this.getCartCookieInfo();
    return items ? items.split(',') : [];
  }

  public getCartNumberItems(): number {
    const items = this.getCartItemsAndQuantities();
    let counter = 0;
    const regex = /.+\[(\d+)\]/;
    for (let i of items) {
      const res = regex.exec(i);
      const quantity = parseInt(res[1], 10);
      counter += quantity;
    }
    return counter;
  }

  public removeItemFromCart(id: string) {
    const items = this.getCartItemsAndQuantities();
    const regex = RegExp(`${id}\\[\\d+\\]`);
    const matchingCartItem = items.find(i => regex.test(i));
    const index = items.indexOf(matchingCartItem);
    items.splice(index, 1);
    const newItems = items.toString();
    this.updateCartItems(newItems, items.length.toString(), false);
  }

  public getItemQuantity(sku: string): number {
    const items = this.getCartItemsAndQuantities();
    const item = items.find((i) => i.includes(sku));
    const regex = /^.+\[(\d+)\]/;
    const res = regex.exec(item);
    const num = parseInt(res[1], 10);
    return num;
  }

  public updateItemQuantity(sku: string, num: number) {
    let cookieText = this.getCartCookieInfo();
    const regex = new RegExp(sku + '\\[(\\d+)\\]');
    const res = regex.exec(cookieText);
    let item = res[0];
    const oldQuantity = parseInt(res[1], 10);
    const newText = cookieText.replace(item, `${sku}[${num}]`);

    const currentCartNumber = this.getCartNumberItems();
    const quantityUpdateDelta = num - oldQuantity;
    const newCartNumber = (currentCartNumber + quantityUpdateDelta).toString();
    this.updateCartItems(newText, newCartNumber, false);
  }

  private updateCartItems(items: string, newNumber: string, animate: boolean=true) {
    const d = new Date();
    d.setTime(d.getTime() + (24 * 60 * 60 * 1000));
    const expires = `expires=${d.toUTCString()}`;
    document.cookie = `shopping_cart=${items};${expires};path=/`;
    this.cartNumber.emit({num: newNumber, animate: animate});
  }

  public isInCart(id: string): boolean {
    const items = this.getCartItems();
    return items.includes(id);
  }

  public resetNavCart() {
    this.cartNumber.emit({num: '0', animate: false});
  }
}
